// File d'attente des photos prises hors-ligne.
// Les blobs compressés sont gardés en IndexedDB (le quota localStorage est
// trop petit pour des images) jusqu'à ce que le réseau permette l'upload S3.

const DB_NAME = 'apex-pro';
const STORE = 'pendingPhotos';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(db, mode, fn) {
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const req = fn(store);
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
}

// Stocke un blob et retourne son id d'attente
export async function queuePhoto(blob) {
  const id = `pend-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  const db = await openDb();
  await tx(db, 'readwrite', (s) => s.put(blob, id));
  return id;
}

export async function getPendingBlob(id) {
  const db = await openDb();
  return tx(db, 'readonly', (s) => s.get(id));
}

export async function deletePending(id) {
  const db = await openDb();
  return tx(db, 'readwrite', (s) => s.delete(id));
}
